import { Injectable } from "@angular/core";
import * as Highcharts from "highcharts";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class HighchartOptionsService {
  constructor() {}

  lineQoSChart = (
    data:any, 
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitleThroughput: string = '',
    yTitleDownTime: string = '',
    yTitleLatency: string = '',
    plotOptions?: any) => {
    return {
      chart: {
          type: 'line',
          borderColor: '#ddd',
          borderWidth: 1
      },
      colors: Highcharts.getOptions().colors,
      plotOptions: {
          series: {
              dataLabels: {
                  enabled: false
              }
          }
      },
      tooltip: {
          shared: true,
          valueDecimals: 2
      },
      xAxis: {
          type: 'datetime',
          crosshair: true
      },
      yAxis: [{
          labels: {
              format: '{value} kbps',
              style: {
                  color: Highcharts.getOptions().colors[2]
              }
          },
          title: {
              text: yTitleThroughput,
              style: {
                  color: Highcharts.getOptions().colors[2]
              }
          },
          opposite: true,
          alignTicks: false

      }, {
          gridLineWidth: 0,
          labels: {
              format: '{value} s',
              style: {
                  color: Highcharts.getOptions().colors[0]
              }
          },
          title: {
              text: yTitleDownTime,
              style: {
                  color: Highcharts.getOptions().colors[0]
              }
          },
          alignTicks: false

      }, {
          gridLineWidth: 0,
          title: {
              text: yTitleLatency,
              style: {
                  color: Highcharts.getOptions().colors[1]
              }
          },
          labels: {
              format: '{value} ms',
              style: {
                  color: Highcharts.getOptions().colors[1]
              }
          },
          opposite: true
      }],
      title: {
          text: title
      },
      legend: {
          labelFormat: '{name}',
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom'
      },
      series: data
    }
  }

  lineChart = (
    data: any[],
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitle: string = '',
    plotOptions?: any
  ) => {
    return {
      chart: {
        type: "line",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      plotOptions: plotOptions || (isStacked
        ? {
            column: {
              stacking: "normal",
              dataLabels: {
                enabled: true,
                format: "{point.y:,.2f}",
              },
            },
            series: {
              dataLabels: {
                enabled: true,
                format: "{point.y:,.2f}",
              },
            },
          }
        : {
            column: {
              dataLabels: {
                enabled: true,
                format: "{point.y}",
              },
            },
            series: {
              dataLabels: {
                enabled: true,
                format: "{point.y}",
              },
            },
          }),
      xAxis: {
        categories,
      },
      yAxis: {
        title: {
          text: yTitle
        }
      },
      stackLabels: {
        enabled: true,
      },
      legend: showLegend
        ? {
            labelFormat: dataLabelsFormat,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
          }
        : {
            enabled: false,
          },
      title: {
        useHTML: true,
        text: title,
      },
      series: data,
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
        shared: true,
      },
    };
  };

  pieChart = (
    data: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string
  ):  Highcharts.Options => {
    return {
      chart: {
        type: "pie",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: dataLabelsFormat,
            showInLegend: true,
            style: {
              color:
                (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                "black",
            },
          },
        },
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
      },
      title: {
        text: title,
      },
      subtitle: {
        text: subtitle,
      },
      series: [
        {
          data,
        },
      ],
    };
  };

  columnChart = (
    data: any[],
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitle: string = '',
    plotOptions?: any
  ) => {
    return {
      chart: {
        type: "column",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      plotOptions: plotOptions || (isStacked
        ? {
            column: {
              stacking: "normal",
              dataLabels: {
                enabled: true,
                format: "{point.y:,.2f}",
              },
            },
            series: {
              dataLabels: {
                enabled: true,
                format: "{point.y:,.2f}",
              },
            },
          }
        : {
            column: {
              dataLabels: {
                enabled: true,
                format: "{point.y}",
              },
            },
            series: {
              dataLabels: {
                enabled: true,
                format: "{point.y}",
              },
            },
          }),
      xAxis: {
        categories,
      },
      yAxis: {
        title: {
          text: yTitle
        }
      },
      stackLabels: {
        enabled: true,
      },
      legend: showLegend
        ? {
            labelFormat: dataLabelsFormat,
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
          }
        : {
            enabled: false,
          },
      title: {
        useHTML: true,
        text: title,
      },
      series: data,
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
        shared: true,
      },
    };
  };
}
